import { takeEvery, takeLatest, call, put } from 'redux-saga/effects';

import {
  ADMIN,
  receiveUserRoles,
  receiveUserRolesError,
  receiveCampaigns,
  receiveCampaignError,
  receiveProducts,
  receiveProductsError,
  receiveUpdatedProducts,
  receiveUpdatedProductsError,
  receiveAllCategories,
  receiveAllCategoriesError,
  receiveCategoriesCampaign,
  receiveCategoriesCampaignError,
  receiveUpdatedCategories,
  receiveUpdatedCategoriesError,
} from 'services/actions/adminActions';
import { getUserRoles } from 'services/api/account';
import {
  getCampaigns,
  getProductsByCampaignId,
  updateProducts,
} from 'services/api/admin-campaigns';
import {
  getAllCategories,
  getCategoriesByCampaignId,
  updateCategories,
} from 'services/api/admin-categories';

const {
  REQUEST_USER_ROLES,
  REQUEST_CAMPAIGNS,
  REQUEST_PRODUCTS,
  REQUEST_UPDATE_PRODUCTS,
  REQUEST_ALL_CATEGORIES,
  REQUEST_CATEGORIES_CAMPAIGN,
  REQUEST_UPDATE_CATEGORIES,
} = ADMIN;

export function* fetchUserRoles() {
  try {
    const response = yield call(getUserRoles);
    yield put(receiveUserRoles(response.roles));
  } catch (error) {
    yield put(receiveUserRolesError(error));
  }
}

export function* fetchCampaigns() {
  try {
    const campaigns = yield call(getCampaigns);
    yield put(receiveCampaigns(campaigns));
  } catch (error) {
    yield put(receiveCampaignError(error));
  }
}

export function* fetchProducts({ campaignId }) {
  try {
    const { products, variants } = yield call(
      getProductsByCampaignId,
      campaignId
    );
    yield put(receiveProducts(products, variants));
  } catch (error) {
    yield put(receiveProductsError(error));
  }
}

export function* fetchUpdatedProducts({
  campaignId,
  productsToUpdate,
  rowId,
  updateProductsCallback,
}) {
  try {
    const { updatedProducts, variants, error } = yield call(
      updateProducts,
      campaignId,
      productsToUpdate
    );
    if (error) {
      yield put(receiveUpdatedProductsError(error, rowId));
    } else {
      yield put(receiveUpdatedProducts(updatedProducts, variants, rowId));
    }
    updateProductsCallback(error);
  } catch (error) {
    yield put(receiveUpdatedProductsError(error, rowId));
    updateProductsCallback(error);
  }
}

export function* fetchAllCategories() {
  try {
    const categories = yield call(getAllCategories);
    yield put(receiveAllCategories(categories));
  } catch (error) {
    yield put(receiveAllCategoriesError(error));
  }
}

export function* fetchCategoriesByCampaignId({ campaignId }) {
  try {
    const categories = yield call(getCategoriesByCampaignId, campaignId);
    yield put(receiveCategoriesCampaign(categories));
  } catch (error) {
    yield put(receiveCategoriesCampaignError(error));
  }
}

const getUpdatedCategories = (categories, categoryId, subcategories) => {
  const categoryList = categories;
  const categoryIndex = categoryList.findIndex(
    (category) => category.id === categoryId
  );
  categoryList[categoryIndex] = {
    ...categoryList[categoryIndex],
    children: subcategories,
  };
  return categoryList;
};

export function* fetchUpdatedCategories({
  campaignId,
  updatedCategories,
  parentId,
  categories,
}) {
  const data = parentId
    ? getUpdatedCategories(categories, parentId, updatedCategories)
    : updatedCategories;
  try {
    yield call(updateCategories, campaignId, data);
    yield put(receiveUpdatedCategories(updatedCategories, parentId));
  } catch (error) {
    yield put(receiveUpdatedCategoriesError(error));
  }
}

// watcher sagas
export function* watchFetchAdminData() {
  yield takeEvery(REQUEST_USER_ROLES, fetchUserRoles);
  yield takeEvery(REQUEST_CAMPAIGNS, fetchCampaigns);
  yield takeEvery(REQUEST_PRODUCTS, fetchProducts);
  yield takeEvery(REQUEST_UPDATE_PRODUCTS, fetchUpdatedProducts);
  yield takeEvery(REQUEST_ALL_CATEGORIES, fetchAllCategories);
  yield takeEvery(REQUEST_CATEGORIES_CAMPAIGN, fetchCategoriesByCampaignId);
  yield takeLatest(REQUEST_UPDATE_CATEGORIES, fetchUpdatedCategories);
}
